import { ChangeDetectionStrategy, Component, Inject, OnDestroy, ViewEncapsulation } from '@angular/core'
import { GbAuthDialogViewService } from '../gb-auth-dialog-view-service/gb-auth-dialog-view.service'
import { AuthDialogStepEnum } from '../gb-auth-dialog.models'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { RegisterExtras } from 'libs/gb-front/auth/data-access/src/lib/+state/auth.models'

@Component({
  selector: 'gb-auth-dialog',
  templateUrl: './gb-auth-dialog.component.html',
  styleUrls: ['./gb-auth-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbAuthDialogComponent implements OnDestroy {
  authDialogStep$ = this.gbAuthDialogViewService.authDialogStep$
  AuthDialogStep = AuthDialogStepEnum

  constructor(
    private gbAuthDialogViewService: GbAuthDialogViewService,
    @Inject(MAT_DIALOG_DATA) public data?: RegisterExtras,
  ) {}

  ngOnDestroy(): void {
    this.gbAuthDialogViewService.goToInitial()
  }

  onRegister(): void {
    this.gbAuthDialogViewService.goToRegister()
  }

  onLogin(): void {
    this.gbAuthDialogViewService.goToLogin()
  }
}
